import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { TextLink } from "../TextLink";
import { Flex } from "../Flex";
import { CopyText } from "../CopyText";
import { Button } from "../Button";

import styles from "./LoginBox.scss";

const LoginBox = forwardRef(
  ({ loggedIn, username, primaryLinks, secondaryLinks }, ref) => (
    <div className={styles.loginBox} ref={ref}>
      <Flex
        customClass={styles.loginBoxContent}
        alignItems="flex-start"
        flexDirection="column"
      >
        <ul className={styles.loginBoxPrimaryList}>
          {primaryLinks &&
            primaryLinks.map((link) => (
              <li key={link.href} className={styles.loginBoxListItem}>
                <a className={styles.loginBoxNavLink} href={link.href}>
                  {link.text}
                </a>
              </li>
            ))}
        </ul>
        <ul className={styles.loginBoxSecondaryList}>
          {secondaryLinks &&
            secondaryLinks.map((link) => (
              <li key={link.href} className={styles.loginBoxListItem}>
                <a className={styles.loginBoxNavLink} href={link.href}>
                  {link.text}
                </a>
              </li>
            ))}
        </ul>
        <span className={styles.loginBoxDivider} />
        {loggedIn ? (
          <>
            <CopyText
              variants={[CopyText.Variant.additional]}
              customClass={styles.loginBoxHeader}
              tag="span"
            >
              Eingelogt als
            </CopyText>
            <CopyText
              variants={[CopyText.Variant.additional]}
              customClass={styles.loginBoxUsername}
              tag="span"
            >
              {username}
            </CopyText>
            <Button
              href="https://www.telekom.de/kundencenter/login?redirectUrl=%2Fkundencenter%2Fstartseite&showCancelButton=false"
              data-tealium-rel="navi-top.button.logout"
              customClass={styles.loginBoxButton}
            >
              Logout
            </Button>
            <div className={styles.loginBoxSubtextDense}>
              <TextLink
                href="#login-einstellungen"
                data-tealium-rel="navi-top.text.login-einstellungen"
              >
                Login Einstellungen
              </TextLink>
            </div>
          </>
        ) : (
          <>
            <CopyText
              variants={[CopyText.Variant.additional]}
              customClass={styles.loginBoxCopytext}
              tag="span"
            >
              Im Kundencenter können Sie Verträge verwalten und auf Rechnungen,
              Verbrauchsanzeigen, Einstellungen und mehr zugreifen.
            </CopyText>
            <Button
              href="https://www.telekom.de/kundencenter/login?redirectUrl=%2Fkundencenter%2Fstartseite&showCancelButton=false"
              data-tealium-rel="navi-top.button.login"
              customClass={styles.loginBoxButton}
            >
              Login
            </Button>
            <div className={styles.loginBoxSubtext}>
              <TextLink href="">Hilfe zum Login</TextLink>
              <div>
                Noch nicht registriert?&nbsp;
                <TextLink
                  href="https://meinkonto.telekom-dienste.de/telekom/account/registration/assistant/index.xhtml?sid=telekomde"
                  data-tealium-rel="navi-top.text.jetzt-registrieren"
                >
                  Jetzt registrieren
                </TextLink>
              </div>
            </div>
          </>
        )}
      </Flex>
    </div>
  )
);

LoginBox.propTypes = {
  loggedIn: PropTypes.bool,
  username: PropTypes.string,
  primaryLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
    })
  ),
  secondaryLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

LoginBox.defaultProps = {
  loggedIn: false,
  username: "",
  primaryLinks: undefined,
  secondaryLinks: undefined,
};

LoginBox.displayName = "GlobalHeader.LoginBox";

export default LoginBox;
